/**
 * Wait for the main thread to be free (unobstructed)
 *
 * Inspired by: https://github.com/caiogondim/obstructed.js/blob/master/src/index.js
 * (But threshold check logic reversed as this library is designed to wait for obstruction)
 * Executes callback when the main thread shows low activity
 * (execution time delta is below threshold)
 */
const unobstructed = (callback, options) => {
    var _a;
    const threshold = (_a = options === null || options === void 0 ? void 0 : options.threshold) !== null && _a !== void 0 ? _a : 10;
    const maxTime = options === null || options === void 0 ? void 0 : options.maxTime;
    let lastExecuted = performance.now();
    const timeToCheckMainThread = 100;
    let timeElapsed = 0;
    const interval = setInterval(() => {
        const delta = performance.now() - lastExecuted;
        timeElapsed += delta;
        if (maxTime && timeElapsed > maxTime) {
            callback(Math.round(delta - timeToCheckMainThread));
            return clearInterval(interval);
        }
        // If delta is close to expected interval time, main thread is assumed to be
        // available
        if ((delta - timeToCheckMainThread) <= threshold) {
            callback(Math.round(delta - timeToCheckMainThread));
            return clearInterval(interval);
        }
        lastExecuted = performance.now();
    }, timeToCheckMainThread);
    return interval;
};

export { unobstructed };
